import { render, staticRenderFns } from "./MenuSideBar.vue?vue&type=template&id=9fefd04a&scoped=true"
import script from "./MenuSideBar.vue?vue&type=script&lang=js"
export * from "./MenuSideBar.vue?vue&type=script&lang=js"
import style0 from "./MenuSideBar.vue?vue&type=style&index=0&id=9fefd04a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fefd04a",
  null
  
)

export default component.exports